import React from 'react';
import { Tooltip, SvgIconProps } from '@mui/material';
import { useLocation, useHistory } from 'react-router-dom';
import { colors } from 'Constants/Colors';
import { ReportsButton, StyledReportsButtonGroup } from './ReportsButtonGroup.styled';

export interface ReportButtonConfig {
  icon: React.ReactNode;
  tooltip: string;
  route: string;
  activeRoute?: string;
  onClick?(): void;
}

interface ReportsButtonGroupProps {
  buttons: ReportButtonConfig[];
}

export const ReportsButtonGroup = ({ buttons }: ReportsButtonGroupProps) => {
  const location = useLocation();
  const history = useHistory();

  const isActiveRoute = (route: string, activeRoute?: string) => {
    const routeToCheck = activeRoute ?? route;
    return location.pathname.includes(routeToCheck);
  };

  return (
    <StyledReportsButtonGroup variant="contained">
      {buttons.map((button, index) => {
        const isActive = isActiveRoute(button.route, button.activeRoute);
        const IconElement = button.icon as React.ReactElement<SvgIconProps>;

        return (
          <Tooltip key={index} title={button.tooltip} placement="bottom" arrow>
            <ReportsButton onClick={button.onClick ?? (() => history.push(button.route))}>
              {React.cloneElement(IconElement, {
                style: { color: isActive ? colors.GREEN : colors.GRAY },
              })}
            </ReportsButton>
          </Tooltip>
        );
      })}
    </StyledReportsButtonGroup>
  );
};
